import { OrderType } from 'apiConnector/secondary-market/batch/model';
import classNames from 'classnames';
import { useAppSelector } from 'hooks/useAppSelector';
import { AnalyticCategoryActions } from 'models';
import { useNavigate } from 'react-router-dom';
import { OrderTypeItem } from 'routes/secondary-market-batch/header/order-type-item';
import { useOrderType } from 'routes/secondary-market-batch/hooks/use-order-type';
import { logAnalytics } from 'shared/middlewares/analytics/logger';
import { getAvailableOrderTypes } from 'state/selectors/meta/secondary-market';

const analyticsEventByOrderType: Record<OrderType, string> = {
  'cp-order': 'CP orders',
  'ebiz-quote': 'Quotes',
  'live-quote': 'Live quotes',
};

export const OrderTypeSelector = () => {
  const navigate = useNavigate();
  const availableOrderTypes = useAppSelector(getAvailableOrderTypes);
  const { orderType: activeOrderType } = useOrderType();
  const handleChange = (selected: OrderType) => {
    if (selected === activeOrderType) {
      return;
    }
    navigate(`/secondary-market-batch/${selected}`);
    logAnalytics.trackEvent(
      'Secondary market batch',
      `Switch to ${analyticsEventByOrderType[selected]} tab` as AnalyticCategoryActions['Secondary market batch'],
    );
  };

  if (availableOrderTypes.length < 2) {
    return null;
  }

  return (
    <div className={classNames('d-flex align-items-center justify-content-between')}>
      <div className="d-flex">
        {availableOrderTypes.map(option => (
          <OrderTypeItem key={option} option={option} activeOrderType={activeOrderType} handleChange={handleChange} />
        ))}
      </div>
    </div>
  );
};
